import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3123a806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progressplaninfo-container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "top1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务名称：", -1))
const _hoisted_5 = { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_6 = { class: "top2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划开始时间：", -1))
const _hoisted_8 = { class: "top3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划完成时间", -1))
const _hoisted_10 = { class: "top4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实际完成时间：", -1))
const _hoisted_12 = { class: "top5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审批状态：", -1))
const _hoisted_14 = { class: "top6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务类型：", -1))
const _hoisted_16 = { class: "top7" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "完成标准：")
], -1))
const _hoisted_18 = { class: "bottom-container" }
const _hoisted_19 = { class: "center-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发起人：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "进度审批人：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "调整审批人：", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "责任人：", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "责任人电话：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.progressDetail.name ? _ctx.progressDetail.name : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.startPlan
              ? _ctx.progressDetail.startPlan.substr(0, 10)
              : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.endPlan ? _ctx.progressDetail.endPlan.substr(0, 10) : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.endReal ? _ctx.progressDetail.endReal.substr(0, 10) : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", {
          style: _normalizeStyle({
            color:
              _ctx.progressDetail.approveStatus === 0
                ? '#FEA235'
                : _ctx.progressDetail.approveStatus === 1
                ? '#C820E0'
                : _ctx.progressDetail.approveStatus === 2
                ? '#8893A3'
                : '#E02020',
          })
        }, _toDisplayString(_ctx.approveStatusFilter(_ctx.progressDetail.approveStatus)), 5)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.typeName ? _ctx.progressDetail.typeName : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.completeCriteria
                ? _ctx.progressDetail.completeCriteria
                : ""), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.initApprovalUserName
                ? _ctx.progressDetail.initApprovalUserName
                : ""), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_21,
          _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.processApproveUserName
                ? _ctx.progressDetail.processApproveUserName
                : ""), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_22,
          _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.planModifyApproveUserName
                ? _ctx.progressDetail.planModifyApproveUserName
                : ""), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_23,
        _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.responsibleUserName
            ? _ctx.progressDetail.responsibleUserName
            : ""), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_24,
        _createElementVNode("span", null, _toDisplayString(_ctx.progressDetail.responsibleUserPhoneNum
            ? _ctx.progressDetail.responsibleUserPhoneNum
            : ""), 1)
      ])
    ])
  ]))
}